module.exports = __webpack_public_path__ + "4d9034317e547681fe7977c2fe5ebbc1.MP3";